import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-arrowdownleft",
  "use": "icon-th-arrowdownleft-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-arrowdownleft\">\n<path d=\"M24.7075 8.70751L10.4137 23H21C21.2652 23 21.5196 23.1054 21.7071 23.2929C21.8946 23.4804 22 23.7348 22 24C22 24.2652 21.8946 24.5196 21.7071 24.7071C21.5196 24.8947 21.2652 25 21 25H8C7.73478 25 7.48043 24.8947 7.29289 24.7071C7.10536 24.5196 7 24.2652 7 24V11C7 10.7348 7.10536 10.4804 7.29289 10.2929C7.48043 10.1054 7.73478 10 8 10C8.26522 10 8.51957 10.1054 8.70711 10.2929C8.89464 10.4804 9 10.7348 9 11V21.5863L23.2925 7.29251C23.3854 7.1996 23.4957 7.1259 23.6171 7.07561C23.7385 7.02533 23.8686 6.99945 24 6.99945C24.1314 6.99945 24.2615 7.02533 24.3829 7.07561C24.5043 7.1259 24.6146 7.1996 24.7075 7.29251C24.8004 7.38542 24.8741 7.49572 24.9244 7.61711C24.9747 7.7385 25.0006 7.86861 25.0006 8.00001C25.0006 8.1314 24.9747 8.26151 24.9244 8.3829C24.8741 8.5043 24.8004 8.6146 24.7075 8.70751Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-arrowdownleft.svg
// module id = yrpw
// module chunks = 84